require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-121-teamgantt-app-for-ios.json") })
        }
      }, "path---article-121-teamgantt-app-for-ios");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-121-teamgantt-app-for-ios!./.cache/json/article-121-teamgantt-app-for-ios.json
// module id = 478
// module chunks = 231608221292675